import Buttons from './buttons';

export default Buttons;
